import type { AnalyticsProvider, AnalyticsEventName, AnalyticsPayload } from "./types"
import { getAttributionData, getOrCreateAnonymousId, getOrCreateSessionId } from "./attribution"
import { subscribeCookieConsent } from "./cookie-consent"
import { consoleProvider } from "./providers/console"
import { gaProvider } from "./providers/ga"
import { pixelProvider } from "./providers/pixel"

const providers: AnalyticsProvider[] = []

function startTrackingProviders() {
  for (const provider of [gaProvider, pixelProvider]) {
    try {
      provider.init()
    } catch {
      /* never block app */
    }
  }
}

export function initAnalytics() {
  if (typeof window === "undefined") return

  subscribeCookieConsent((choice) => {
    if (choice === "all" || choice === "necessary") startTrackingProviders()
  })

  providers.push(gaProvider, pixelProvider)

  if (import.meta.env.DEV) {
    providers.push(consoleProvider)
  }

  providers.forEach((p) => {
    try {
      p.init()
    } catch {
      /* never block app */
    }
  })
}

export function registerProvider(provider: AnalyticsProvider) {
  providers.push(provider)
  try {
    provider.init()
  } catch {
    /* ignore */
  }
}

export function trackEvent(
  eventName: AnalyticsEventName,
  params: Partial<Omit<AnalyticsPayload, "eventName" | "attribution">> = {},
) {
  const payload: AnalyticsPayload = {
    eventName,
    anonymousId: getOrCreateAnonymousId(),
    sessionId: getOrCreateSessionId(),
    attribution: getAttributionData(),
    ...params,
  }

  providers.forEach((p) => {
    try {
      p.track(eventName, payload)
    } catch {
      /* swallow */
    }
  })
}

export function trackPageView(path: string) {
  providers.forEach((p) => {
    try {
      p.page(path)
    } catch {
      /* swallow */
    }
  })
}
